export const validateMessages = {
  required: 'Required',
  types: {
    email: 'Not a valid email address',
    password: 'Not a valid password'
  }
};

export const MIN_PASSWORD_LENGTH = 12; // Changed to 12 to increase security
export const RECAPTCHA_ERROR = 'There was an issue with our reCAPTCHA security, please reload the page and try again.';